import { clientEnv } from "@/env/client";

import type { AppRouter } from "@promptwatch/server/src/router";
import { httpLink, loggerLink } from "@trpc/client";
import { ssrPrepass } from "@trpc/next/ssrPrepass";
import { createTRPCNext } from "@trpc/next";
import type { inferRouterInputs, inferRouterOutputs } from "@trpc/server";
import superjson from "superjson";

export const trpc = createTRPCNext<AppRouter>({
  transformer: superjson,
  ssrPrepass,
  config() {
    return {
      queryClientConfig: {
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: true,
          },
        },
      },
      links: [
        loggerLink({
          enabled: () => clientEnv.NODE_ENV === "development",
        }),
        httpLink({
          transformer: superjson,
          url: `${clientEnv.NEXT_PUBLIC_SERVER_URL}/trpc`,
          headers() {
            if (typeof window !== "undefined") {
              const token = localStorage.getItem("free-tools-token");

              if (token) {
                return {
                  Authorization: `Token ${token}`,
                };
              }
            }

            return {};
          },
        }),
      ],
    };
  },
  ssr: true,
});

export type RouterInputs = inferRouterInputs<AppRouter>;
export type RouterOutputs = inferRouterOutputs<AppRouter>;
